<div class="waiting-card-dialog">
  <div class="close-header">
    <button class="close-btn" (click)="closeDialog()">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <ng-container *ngIf="!isCheckingStatus">
    <div class="content-wrapper">
      <div class="icon-wrapper">
        <app-svg-loader url="pin-locked.svg"></app-svg-loader>
      </div>
      <div class="text-wrapper">
        <h2 class="title">Waiting for Card Setup</h2>
        <p class="subtitle">
          Please finish entering your card details and complete verification in the opened window.
        </p>
      </div>
      <div class="button-wrapper">
        <button class="check-status-btn" (click)="checkStatus()">Check Status</button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isCheckingStatus">
    <div class="loading-wrapper">
      <div class="spinner icon progress-spinner"></div>
    </div>
  </ng-container>
</div>